function SentinelCreateVisitModal($rootScope, $timeout, sentinelService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {},
		template: require('./visit-modal.html'),

        link: function (scope, element) {
            $timeout(function() {
                element.selectpicker();
            });
            sentinelService.getFacilitiesList($rootScope.selectedLog.id).then(function(facilities) {
                scope.availableFacilities = facilities;
            });

            scope.visit = {};
            scope.requiredFields = {};
            scope.cameraAccess = false;
            scope.modalWidth = 350;
            scope.canvasPadding = 60;

            scope.hideModal = function () {
                scope.clearVisit();
                sentinelService.sentinel.createModalOpen = false;
                $('#create-visit-modal').modal('hide');
                $rootScope.$broadcast('sentinel-hide-create-modal');
            };

            scope.selectFacility = function() {
                scope.visit.facilityName = scope.selectedFacility;
                sentinelService.getRequiredFields($rootScope.selectedLog.id, scope.visit.facilityName).then(function (rf) {
                    scope.requiredFields = rf;
                });
            };

            scope.isReq = function (name) {
                return (scope.requiredFields && scope.requiredFields[name] === "required");
            };

            scope.isVis = function (name) {
                return (scope.requiredFields && scope.requiredFields[name] !== "disabled");
            };

            scope.showPicturePreview = function () {
                scope.showPicture = true;
                scope.canvasPadding = (scope.modalWidth / 2) - 120;
            };

            scope.hidePicturePreview = function () {
                scope.showPicture = false;
                scope.pictureTaken = false;
            };

            scope.retakePicture = function () {
                scope.pictureTaken = false;
            };

            scope.takePicture = function () {
                scope.pictureTaken = true;
                var video = document.getElementById('video');
                if (video) {
                    var canvas = document.getElementById('pictureCanvas');
                    if (canvas) {
                        canvas.width = 200;
                        canvas.height = 200;
                        var canvasCtx = canvas.getContext('2d');
                        var imgData = scope.getVideoData((video.width / 2) - 100, (video.height / 2) - 100, 200, 200);
                        canvasCtx.putImageData(imgData, 0, 0);
                    }
                }
            };

            scope.getVideoData = function (x, y, w, h) {
                var hiddenCanvas = document.createElement('canvas');
                var video = document.getElementById('video');
                hiddenCanvas.width = video.width;
                hiddenCanvas.height = video.height;
                var ctx = hiddenCanvas.getContext('2d');
                ctx.drawImage(video, 0, 0, video.width, video.height);
                return ctx.getImageData(x, y, w, h);
            };

            scope.createGuest = function () {
                scope.visit.facilityName = scope.selectedFacility;

                if (scope.pictureTaken) {
                    scope.visit.pictureBase64 = document.getElementById('pictureCanvas').toDataURL();
                } else {
                    scope.visit.pictureBase64 = null;
                    scope.visit.profilePicture = null;
                }

                console.log("scope.visit right before we call sentinelService.createRegisteredGuests");
                console.log(scope.visit);
                sentinelService.createRegisteredGuest(scope.visit);

                this.hideModal();
            };

            scope.clearVisit = function() {
                scope.visit = {};
                scope.showPicture = false;
                scope.pictureTaken = false;
            };

            function accessCamera () {
                var video = document.getElementById('video');
                if (navigator.mediaDevices) {
                    navigator.mediaDevices.getUserMedia({video: {width: {ideal: 200, max: 320}, height: {ideal: 200, max: 320}}, audio: false})
                        .then(function(stream) {
                            console.log("ON VIDEO STREAMING");
                            scope.cameraAccess = true;
                            if ('srcObject' in video) {
                                video.srcObject = stream;
                            } else {
                                video.src = window.URL.createObjectURL(stream);
                            }
                            $rootScope.$broadcast('sentinel-create-video-stream-set', {stream: stream});
                        })
                        .catch(function() {
                            navigator.mediaDevices.getUserMedia({video: true, audio: false})
                                .then(function(stream) {
                                    console.log("ON VIDEO STREAMING");
                                    scope.cameraAccess = true;
                                    if ('srcObject' in video) {
                                        video.srcObject = stream;
                                    } else {
                                        video.src = window.URL.createObjectURL(stream);
                                    }
                                    $rootScope.$broadcast('sentinel-create-video-stream-set', {stream: stream});
                                })
                                .catch(function(error) {
                                    console.log("ON VIDEO ERROR: ");
                                    console.log(error);
                                    scope.cameraAccess = false;
                                    document.getElementById('pictureErrorMessage').innerHTML = 'Cannot access camera';
                                });
                        });
                } else {
                    console.log("BROWSER DOESN'T SUPPORT navigator.mediaDevices");
                    scope.cameraAccess = false;
                    document.getElementById('pictureErrorMessage').innerHTML = 'This browser does not support cameras';
                }

            }

            scope.$on('sentinel-show-create-modal', function () {
                scope.cameraAccess = false;
                document.getElementById('pictureErrorMessage').innerHTML = 'Attempting to access camera...';
                accessCamera();
            });
        }
    }
}

angular.module('sentinel').directive('sentinelCreateVisitModal', ['$rootScope', '$timeout', 'sentinelService', SentinelCreateVisitModal]);
